import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import { odata } from "../Filters/Helper";
import TosPaymentTableFilter from "../Filters/TosPaymentTableFilter";
import TosPaymentAddForm from "../Forms/TosPaymentAddForm";
import TosPaymentUpdateForm from "../Forms/TosPaymentUpdateForm";
import TosCreateOrderForm from "../Forms/TosCreateOrderForm";

import moment from "moment";

import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Modal,
  Tooltip, Select, notification, DatePicker, Form
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SendOutlined,
} from "@ant-design/icons";
import CurrencyFormat from "react-currency-format";
import { useRef } from "react";
import { useForm } from "antd/lib/form/util";

const TosPayment = (props) => {

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      md: {
        span: 24,
      },
      lg: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      md: {
        span: 24,
      },
      lg: {
        span: 12,
      },
    },
  };

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 200,
    current: 1,
    filter: "&$filter=statusId eq 1",
  });
  const [order, setOrder] = useState("");
  const [addPaymentVisibility, setAddPaymentVisibility] = useState(false);
  const [updatePaymentVisibility, setUpdatePaymentVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: [],
  });
  const [createOrderModalVisible, setCreateOrderModalVisible] = useState(false);

  const [isTosAuthorize, setIsTosAuthorize] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedCurrencyCode, setSelectedCurrencyCode] = useState(null);

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [hasUsePdf, setHasUsePdf] = useState(false);


  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [showValueDateModal, setShowValueDateModal] = useState(false);

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  const [buttonLoading, setButtonLoading] = useState(false);
  const [currencyId, setCurrencyId] = useState(1);
  const [isAllowGetFromErp, setIsAllowGetFromErp] = useState(false);


  const [form] = Form.useForm();

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  useEffect(() => {
    RequestHandler.get("/TenantUser/IsTosAuthorize").then((response) => {
       setIsTosAuthorize(response);
    });




    RequestHandler.get("/Payment/CurrencyList").then((response) => {
      setCurrencySelect({
        data: response.data,
        loading: false,
      });
    });

    RequestHandler.get(
      `/TosBankInfo?$filter=isUsePdf eq true`
    ).then((response) => {
      setHasUsePdf(response.value.length > 0);
    });

     RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsAllowGetFromErp(response.isTosPaymentGetFromErp);
      }
    });
  }, [])

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });
     RequestHandler.get(
       `/Payment?$count=true${filter}${order}&$skip=${skip}&$top=${take}`
     ).then((response) => {
         setTableData({
           data: response.value,
           total: response["@odata.count"],
           loading: false
         });

         setTotalCount(response["@odata.count"]);
     });

     const aggregateFilter = filter.replace(/^&\$filter=/, "");

      RequestHandler.get(
        `/Payment?$apply=filter(${aggregateFilter})/aggregate(Amount with sum as TotalAmount)`
      ).then((response) => {
        setTotalAmount(response?.[0]?.totalAmount ?? 0);
      });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "&$filter=statusId eq 1",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const handleOnClickUpdate = (record) => {
      RequestHandler.get(
        `/payment?$select=id,title,accountNumber,iban,bankId,bankBranchId,currencyId,paymentDate,description, swiftCode,referenceCode,valueDate, tcknVkn&$filter=id eq ${record.id}`
      ).then((response) => {
        const [tenant] = response.value;
        if (tenant) {
          setUpdateFormData(tenant);
          setUpdatePaymentVisibility(true);
        }
      });
     setUpdateFormData(record);
     setUpdatePaymentVisibility(true);
  };

  const handleOnClickDelete = (id) => {
     RequestHandler.delete(`/payment?id=${id}`).then((response) => {
       if (response.success) {
         getTableData();
       }
     });
  };

  const onAddPaymentSuccess = () => {
    getTableData();
    setAddPaymentVisibility(false);
  };

  const onUpdatePaymentSuccess = () => {
    getTableData();
    setUpdatePaymentVisibility(false);
  };

  const onTableSelectChange = (selectedKeys, selectedRecords) => {

    if(selectedRecords.length > 0  && selectedCurrency == null) {
      setSelectedCurrency(selectedRecords[0].currencyId);
      setSelectedCurrencyCode(selectedRecords[0].currencyCode)
    }

    if(selectedRecords.length == 0) {
      setSelectedCurrency(null);
      setSelectedCurrencyCode(null);
    }

    setSelectedRows({
      keys: selectedKeys,
      data: selectedRecords,
    });
  };

  const onClickCreateOrder = () => {
    setCreateOrderModalVisible(true);
  };

  const onClickRemoveSelected =  () => {
    RequestHandler.delete(`/payment/DeleteSelected`, selectedRows.keys).then((response) => {
      if (response.success) {
        setSelectedRows({
          keys: [],
          data: [],
        });
        getTableData();
      }
    })
  }

  const getAllPayments = () => {
    setButtonLoading(true);
    let {  filter } = tableDataQueryOptions;

    filter = `${filter} and currencyId eq ${currencyId}`;


    RequestHandler.get(
      `/Payment?$count=true${filter}${order}`
    ).then((response) => {
      setButtonLoading(false);
      if(response.value.length > 0) {
        const keys = response.value.map(x=> x.id);


        setSelectedCurrency(response.value[0].currencyId);
        setSelectedCurrencyCode(response.value[0].currencyCode)

        setSelectedRows({
          keys: keys,
          data: response.value,
        });

        setShowCurrencyModal(false);
        setCreateOrderModalVisible(true);
      }
      else {
        notification["error"]({
          message: "Ödeme bulunamadı",
          duration: 5,
        });
      }
    });
  }


  const getPaymentsFromErp = () => {
    setButtonLoading(true);

    const valueDate= moment(form.getFieldValue("valueDate")).format("yyyy-MM-DD");

    RequestHandler.get(
      `/Payment/GetFromErp/${valueDate}`
    ).then((response) => {
      setButtonLoading(false);

      if(response.data) {
        window.location.reload();
      }
    });
  }



  const onChangeCurrencyId = (value) => {
    setCurrencyId(value);
  }


  const columns = [
    {
      title: "Alıcı Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Ad Soyad / Ünvan",
      align:'center',
      dataIndex: "title",
    },
    {
      title: "Alıcı Iban",
      align:'center',
      dataIndex: "iban",
    },
    hasUsePdf  ? {
      title:"Swift Kodu",
      dataIndex:  "swiftCode",
      width: "8%",
    } : {},
    {
      title: "Tutar",
      align:'center',
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      align:'center',
      dataIndex: "currencyCode",
      render: (data, row) => (
         data
      ),
    },
    {
      title: "Referans Numarası",
      align:'center',
      dataIndex: "referanceNumber",
    },
    {
      title: "Ödeme Durumu",
      align:'center',
      dataIndex: "status",
    },

    {
      title: "Durum Mesajı",
      dataIndex: "statusMessage",
    },
    hasUsePdf  ? {
      title:"Valör Tarihi",
      dataIndex: "valueDate",
      width: "8%",
      render: (data,row) => {
        if(data) {
          return moment(data).format("DD.MM.YYYY");
        }

        return null;

      }
    } : {},
    {
      title: "Ödeme Tarihi",
      align:'center',
      dataIndex: "paymentDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    hasUsePdf  ? {
      title:"Referans Kodu",
      dataIndex: "referenceCode",
      width: "8%",
    } : {},
    {
      title: "Açıklama",
      dataIndex: "description",
    },



    {
      title: "Talimatı Ekleyen",
      dataIndex: "addUserName",
    },
    {
      title: "Son Güncelleyen",
      dataIndex: "updateUserName",
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>  {

        if(isTosAuthorize) {
          return   <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        }

        return  <Tooltip title="Düzenleme yetkiniz bulunmamaktadır"><EditOutlined style={{ color: "orange", fontSize: "130%" }} /></Tooltip>
      }

    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data, record) => {

        if(isTosAuthorize) {
          return  <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleOnClickDelete(data)}
          >
            <a>
              <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
            </a>
          </Popconfirm>
        }

        return <Tooltip title="Silme yetkiniz bulunmamaktadır"><DeleteOutlined style={{ color: "red", fontSize: "130%" }} /></Tooltip>

      },
    },
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> ÖDEME LİSTESİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>

            {
              selectedRows.keys.length > 0 && isTosAuthorize ?  <Popconfirm
              title="Seçilen kayıtları silmek istiyor musunuz?"
              okText="Evet"
              cancelText="Hayır"
              onConfirm={onClickRemoveSelected}
            >
              <Button type="danger" disabled={selectedRows.keys.length > 0 && isTosAuthorize ? false : true} style={{ marginBottom: 0 }}>
                <DeleteOutlined /> Sil
              </Button>
             </Popconfirm>
           :  <Button type="danger" disabled={selectedRows.keys.length > 0 && isTosAuthorize ? false : true} style={{ marginBottom: 0 }}>
                  <DeleteOutlined /> Sil
            </Button>
            }

          {isTosAuthorize ? <>
            <Button disabled={selectedRows.keys.length < 1  ? false : true} style={{ marginBottom: 0 }} onClick={() => setShowCurrencyModal(true)}>Tüm Ödemeler için Talimat Oluştur</Button>
          </> : <></>}

            <Button disabled={selectedRows.keys.length > 0 && isTosAuthorize ? false : true} onClick={onClickCreateOrder} style={{ marginBottom: 0 }}>
              <SendOutlined /> Talimat Oluştur
            </Button>

            {isAllowGetFromErp ? <>
             <Button
                type="primary"
                onClick={() => {
                  setShowValueDateModal(true);
                }}
                style={{ marginBottom: 0 }}
                disabled = {!isTosAuthorize}
              >
                <PlusOutlined /> Erp'den Getir
              </Button>
            </> : <></> }
          <Button
            type="primary"
            onClick={() => {
              setAddPaymentVisibility(true);
            }}
            style={{ marginBottom: 0 }}
            disabled = {!isTosAuthorize}
          >
            <PlusOutlined /> Ödeme Ekle
          </Button>
        </Col>
      </Row>

      <TosPaymentTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
         <Col span={20} style={{ textAlign: "end", fontSize: 19 }}>
            <p>Adet : {totalCount} </p>
          </Col>
          <Col span={2} style={{ textAlign: "end", fontSize: 19 }}>
            <p>Tutar :</p>
          </Col>
          <Col span={2} style={{ fontSize: 19 }}>
            <CurrencyFormat
              value={parseFloat(totalAmount)}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
            />
          </Col>
        </Row>

<Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={{
              selectedRowKeys: selectedRows.keys,
              onChange: onTableSelectChange,
              getCheckboxProps: (record) => ({
                disabled:   (!isTosAuthorize || selectedCurrency != null) ? (selectedCurrency !== record.currencyId) : false
              }),
            }}
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["100", "200", "300"],
              showSizeChanger:true,
              total: tableData.total,
              current: tableDataQueryOptions.current
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addPaymentDrawer"
        title="Ödeme Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddPaymentVisibility(false)}
        visible={addPaymentVisibility}
      >
        <TosPaymentAddForm onSuccess={onAddPaymentSuccess} />
      </Drawer>

      <Drawer
        id="updatePaymentDrawer"
        title="Ödeme Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdatePaymentVisibility(false)}
        visible={updatePaymentVisibility}
      >
        <TosPaymentUpdateForm
          data={updateFormData}
          onSuccess={onUpdatePaymentSuccess}
        />
      </Drawer>

      <Modal
        id="createOrderModal"
        centered
        visible={createOrderModalVisible}
        onOk={() => setCreateOrderModalVisible(false)}
        onCancel={() => setCreateOrderModalVisible(false)}
        width={800}
        footer={null}
      >
        <TosCreateOrderForm
          selectedPayments={selectedRows.data}
          data={{ paymentIds: selectedRows.keys }}
          selectedCurrencyId = {selectedCurrency}
          selectedCurrencyCode = {selectedCurrencyCode}
        />
      </Modal>

      <Modal id="currencySelected"
             centered
             visible={showCurrencyModal}
             onOk={getAllPayments}
             onCancel={() => setShowCurrencyModal(false)}
             okText="Ödemeleri Getir"
             cancelText="İptal"
             closable={false}
             confirmLoading={buttonLoading}
      >

        <Row justify="center" align="middle" style={{ minHeight: 80 }}>
          <Col>
            <span style={{ marginRight: 8 }}>Para Birimi:</span>
            <Select
              allowClear
              showSearch
              defaultValue={currencyId}
              value={currencyId}
              onChange={onChangeCurrencyId}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              style={{width: 400}}
            >
              {currencySelect.data.map(({ id, code }) => (
                <Select.Option key={id} value={id}>
                  {code}
                </Select.Option>
              ))}

            </Select>
          </Col>
        </Row>

      </Modal>


      <Modal id="currencySelected"
             centered
             visible={showValueDateModal}
             onOk={getPaymentsFromErp}
             onCancel={() => setShowValueDateModal(false)}
             okText="Ödemeleri Getir"
             cancelText="İptal"
             closable={false}
             confirmLoading={buttonLoading}
      >

        <Row justify="center" align="middle" style={{ minHeight: 80 }}>
        
            <Col span={24}>
               <Form form={form}>
                  <Form.Item label="Vade Tarihi" name="valueDate">
                      <DatePicker format="DD.MM.YYYY" name="valueDate" style={{width: 350}} />
                  </Form.Item>
                </Form>
            </Col>
      
        </Row>

      </Modal>
    </>
  );
};

export default TosPayment;
